interface StoredItem<T> {
  readonly item: T;
  readonly expiration: Date;
}

export const getItem = <T>(key: string): T | null => {
  const storedItem: string | null = localStorage.getItem(key);
  if (!storedItem) return null;

  const storedData = JSON.parse(atob(storedItem));
  const result: StoredItem<T> = {
    item: storedData.item!,
    expiration: new Date(storedData.expiration)
  };

  if (result.expiration < new Date()) {
    localStorage.removeItem(key);
    return null;
  }

  return result.item;
};

export const storeItem = <T>(key: string, item: T, expiration: Date): StoredItem<T> => {
  const result: StoredItem<T> = {
    item: item,
    expiration
  };
  localStorage.setItem(key, btoa(JSON.stringify(result)));

  return result;
};

export const clearItem = <T>(key: string): T | null => {
  const storedItem = getItem<T>(key);
  if (storedItem) localStorage.removeItem(key);

  return storedItem;
};
